// Curaleaf
export const CURALEAF_STRAINS = [
  {
    id: "curaleaf-la-kush-26",
    name: "LA Kush",
    producer: "Curaleaf",
    country: "Kanada",
    genetics: "Hybryda/Indica",
    lineage: "Kush Mints × Wedding Cake",
    thc: 26, cbd: 0.5,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Słodki", "Ziołowy"],
    description: "Hybryda z dominantą indica (60/40) debiutująca na rynku pod szyldem Curaleaf wykazuje silne działanie przeciwzapalne, dzięki dominującemu kariofilenowi, wspierane przez linalol, który dodatkowo wykazuje właściwości uspokajające i anksjolityczne. Efekt przeciwlękowy w badaniach wykazuje również limonen, a mircen może skracać czas potrzebny do zaśnięcia i wydłużać fazy snu.",
    terpenes: { kariofilen: 35, linalol: 29, limonen: 24, mircen: 12 },
    dominantTerpene: "Kariofilen", packaging: "10g",
    dateAdded: "2026-11-04T12:00:00", isNew: true
  }
];